export enum DialogSize {
  Mini = 'mini',
  Tiny = 'tiny',
  Small = 'small',
  Normal = 'normal',
  Large = 'large',
  Fullscreen = 'fullscreen',
}
